import {
  type PipeCustomPayload,
  type PipeVideoType,
} from "@memento/types/pipe";
import { getIllegalCharactersInDisplayNameRegex } from "src/libs/user-lib";

export type GetPipeVideoUploadPayloadProps = {
  username?: string;
  cardId: string;
  cardUrl: string;
  videoType: PipeVideoType;
  compilationId?: string;
  contributor?: {
    contributorId?: string;
    email?: string;
    contributorName?: string;
  };
};

export function getPipeVideoUploadPayload({
  username,
  cardId,
  cardUrl,
  videoType,
  compilationId,
  contributor,
}: GetPipeVideoUploadPayloadProps): PipeCustomPayload {
  return {
    submitterUsername: username,
    cardId,
    cardUrl,
    videoType,
    compilationId,
    contributorId: contributor?.contributorId,
    contributorEmail: contributor?.email,
    contributorName: contributor?.contributorName?.replace(
      getIllegalCharactersInDisplayNameRegex(),
      ""
    ),
  };
}
